import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { ContentEditor } from '@/components/website/ContentEditor';
import { useWebsiteContent, useWebsiteContentVersions } from '@/hooks/useWebsiteContent';
import { Skeleton } from '@/components/ui/skeleton';

export default function CRMWebsiteContentDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { content, updateContent } = useWebsiteContent();
  const { versions } = useWebsiteContentVersions(id);

  const item = content.find(c => c.id === id);

  if (!item) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-[400px] w-full" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="icon" onClick={() => navigate('/crm/website/content')}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-xl font-bold">{item.title}</h1>
      </div>

      <ContentEditor
        content={item}
        versions={versions}
        onSave={(updates) => updateContent.mutate({ id: item.id, ...updates })}
        onRestoreVersion={(v) => updateContent.mutate({ id: item.id, content: v.content, createVersion: true, versionNotes: 'Hersteld van versie' })}
        isSaving={updateContent.isPending}
      />
    </div>
  );
}